var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199.727,
    height: 185.595,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C293A",
    d: "M51.266 14.289h45.77c3.926 0 7.145-3.22 7.145-7.145 0-3.925-3.219-7.144-7.144-7.144h-45.77c-3.926 0-7.145 3.219-7.145 7.144a7.12 7.12 0 0 0 7.144 7.145Zm89.893 17.743H7.144C3.22 32.032 0 35.25 0 39.176 0 43.1 3.219 46.32 7.144 46.32h5.182l9.735 96.566c.785 8.086 7.615 14.21 15.702 14.21h73.327c8.086 0 14.838-6.124 15.702-14.21l9.735-96.566h4.632c3.925 0 7.144-3.219 7.144-7.144-.078-4.004-3.219-7.144-7.144-7.144Zm-59.902 82.67c0 3.925-3.22 7.144-7.145 7.144-3.925 0-7.144-3.22-7.144-7.145V78.038c0-3.926 3.219-7.145 7.144-7.145 3.926 0 7.145 3.22 7.145 7.145V114.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M173.818 103.475c-19.862 10.441-32.424 41.766-32.424 41.766l-7.772-15.387-15.937 9.97c6.751 2.512 16.487 10.442 24.73 20.883 5.81-10.912 23.71-33.287 32.424-35.328-3.454-7.93-1.492-14.446-1.02-21.904Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M146.183 78.509c-29.597 0-53.543 24.023-53.543 53.543 0 29.598 24.024 53.543 53.543 53.543 29.598 0 53.544-24.024 53.544-53.543.078-29.52-23.946-53.543-53.544-53.543Zm-3.847 82.198c-8.243-10.441-17.9-18.37-24.73-20.883l15.937-9.97 7.773 15.387s12.561-31.325 32.424-41.766c-.471 7.458-2.434 13.896.942 21.904-8.636 2.04-26.536 24.337-32.346 35.328Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteInactive);
export default __webpack_public_path__ + "static/media/delete-inactive.4a642fa237cfc9dd8725332142396bca.svg";
export { ForwardRef as ReactComponent };